export default __webpack_public_path__ + "static/media/burger.d8a86d8b.svg";